module.exports = __webpack_public_path__ + "img/Geräusch1.da156dc5.jpg";